<template lang="pug">
//- 免单特权组件 http://wiki.hellobike.com/pages/viewpage.action?pageId=403920307
div(v-if="this.moduleData\
          && this.moduleData.cardPropInfoDTOList\
          && this.moduleData.cardPropInfoDTOList.length")
  .free-rights-container(@click="handleContainerClickUBT")
    img.free-rights-title(
      :src="moduleData.titleImg || ''"
      v-if="!isOpen"
      )
    .free-rights-list
      .free-right-item(
        v-for="item in moduleData.cardPropInfoDTOList.slice(0,4)"
        :class="{ 'opened': isOpen}"
        :style="{ backgroundImage: `url(${item.backgroundUrl})` }"
        @click="handleCardClick(item, $event)"
        v-if="showItem(item)"
      )
        .corner-tip(v-if="item.cornerTip") {{item.cornerTip}}
        //- 生活免单（抽奖）是轮播
        .item-content.swiper-container(v-if="item.type === FREE_RIGHT_TYPE.lottery")
          .swiper-wrapper
            .swiper-slide.lottery-good(
              v-for="(lotteryItem, lotteryIndex) in item.lotteryList"
              :data-item-index="lotteryIndex"
            )
              img.bus-icon(v-if="!isOpen" :src="lotteryItem.busIcon")
              .main-title {{lotteryItem.mainTitle}}
              .card-info {{lotteryItem.subTitle}}
              .button(
                v-if="isOpen"
                :class="getButtonClass({...item, ...lotteryItem})"
              ) {{formatButtonText(lotteryItem.buttonText)}}
              img.lottery-icon(v-if="lotteryItem.imgIcon" :src="lotteryItem.imgIcon")
        //- 其他类型 非轮播
        .item-content(v-else)
          img.bus-icon(v-if=" !isOpen" :src="item.busIcon")
          .main-title {{item.mainTitle}}
          .card-info {{item.subTitle}}
          .button(
            v-if="isOpen && item.status !== FREE_RIGHT_STATUS.remain_days"
            :class="getButtonClass(item)"
            @click.stop="clickButton(item)"
          ) {{item.buttonText}}
          div(
            v-if="isOpen && item.status === FREE_RIGHT_STATUS.remain_days"
            )
            HighlightText.remain-days(
            :text="formatButtonText(item.buttonText)"
            :highlightStyle="highlightStyle"
            :normalStyle="normalStyle"
          )
          img.lottery-icon(v-if="item.imgIcon" :src="item.imgIcon")
  //- 参与成功弹窗，actived样式需置灰，所以直接写true
  involvedDialog(
    :show.sync="showInvolvedDialog"
    :involovedData="involvedData"
  )
</template>
<script>
import Swiper from 'swiper'; // 注意引入的是Swiper
import 'swiper/swiper.min.css';
import HighlightText from '@/components/highlight-text';
import { receiveVipCoupon } from '@/api/vip';
import { getTokenAndKey } from '@/utils';
import Toast from '@/components/toast';
import { Navigator } from '@hb/h5-navigator';
import eventBus from '@/const/eventBus';
import { LotteryUtils } from '@/utils/lottery';
import config from '@/const/config';
import { debounce } from 'lodash';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { ParamsUtil } from '@/utils/params';
import { FREE_RIGHT_TYPE, FREE_RIGHT_STATUS, LOTTERY_PRIZE_STATUS } from '../../../consts';
import involvedDialog from '../involved-dialog.vue';


export default {
  components: {
    HighlightText,
    involvedDialog,
  },
  props: {
    moduleData: {
      type: Object,
      default: () => ({}),
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    currentOrderOptType: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      FREE_RIGHT_TYPE,
      lotterySwiper: null,
      showInvolvedDialog: false,
      involvedData: null,
      FREE_RIGHT_STATUS,
      hasSubscribed: false,
      isJumpRecordPage: false,
      campaignCode: '',
      batchNo: '',
    };
  },
  computed: {
    highlightStyle() {
      return {
        fontFamily: 'DINAlternate',
        height: '0.24rem',
        lineHeight: '0.24rem',
        fontWeight: '700',
        fontSize: '0.2rem',
        color: '#fff',
        marginLeft: '0.01rem',
        marginRight: '0.01rem',
      };
    },
    normalStyle() {
      return {
        fontFamily: 'PingFang SC',
        fontWeight: '500',
        fontSize: '0.12rem',
        color: '#fff',
      };
    },
  },
  watch: {
    moduleData: {
      deep: true,
      immediate: true,
      handler(data) {
        this.handleData(data);
      },
    },
  },
  beforeDestroy() {
    // 组件销毁时清理swiper实例
    if (this.lotterySwiper && this.lotterySwiper.destroy) {
      this.lotterySwiper.destroy(true, true);
    }
    this.lotterySwiper = null;
  },
  mounted() {
    if (this.moduleData
          && this.moduleData.cardPropInfoDTOList
          && this.moduleData.cardPropInfoDTOList.length) {
      if (!this.isOpen) {
        UBT.moduleExpose({
          pageId: 'platform_savemoneycard_page',
          categoryId: 'platform',
          moduleId: 'platform_miandan',
          contentId: 'platform_miandan',
          exposureTimes: 1,
          businessInfo: {},
        });
      }
      if (this.isOpen) {
        UBT.moduleExpose({
          pageId: 'platform_savemoneycard_page',
          categoryId: 'platform',
          moduleId: 'platform_maindan_vip_zhengti',
          contentId: 'platform_maindan_vip_zhengti',
          exposureTimes: 1,
          businessInfo: {},
        });
      }
    }

    this.checkRemind();
  },
  destroyed() {
  },
  methods: {
    handleContainerClickUBT() {
      if (!this.isOpen) {
        UBT.clickButton({
          pageId: 'platform_savemoneycard_page',
          buttonName: 'platform_miandan',
          categoryId: 'platform',
          businessInfo: {},
        });
      } else {
        UBT.clickButton({
          pageId: 'platform_savemoneycard_page',
          buttonName: 'platform_maindan_vip_zhengti',
          categoryId: 'platform',
          businessInfo: {},
        });
      }
    },
    async checkRemind() {
      // 检查是否已订阅抽奖提醒
      LotteryUtils.checkRemind(
        (hasSubscribed) => {
          this.haveSubscribed = hasSubscribed;
        },
        () => {
        },
      );
    },
    // 处理buttonText中的"剩x天"格式
    formatButtonText(text) {
      if (!text || typeof text !== 'string') {
        return text;
      }

      // 匹配"剩x天"的格式，其中x是数字
      const regex = /剩(\d+)天/;
      const match = text.match(regex);

      if (match) {
        // 将匹配到的数字用{}包围
        return text.replace(regex, `剩{${match[1]}}天`);
      }

      return text;
    },
    handleData() {
      this.initSwiper();
      this.moduleExpose();
    },
    moduleExpose() {
      if (this.moduleData
          && this.moduleData.cardPropInfoDTOList
          && this.moduleData.cardPropInfoDTOList.length) {
        this.moduleData.cardPropInfoDTOList.forEach((item) => {
          if (item.type === FREE_RIGHT_TYPE.bike) {
            if (!this.isOpen) {
              UBT.moduleExpose({
                pageId: 'platform_savemoneycard_page',
                categoryId: 'platform',
                moduleId: 'platform_miandan_bike',
                contentId: 'platform_miandan_bike',
                exposureTimes: 1,
                businessInfo: {},
              });
            } else {
              UBT.moduleExpose({
                pageId: 'platform_savemoneycard_page',
                categoryId: 'platform',
                moduleId: 'platform_maindan_vip',
                contentId: 'platform_maindan_vip',
                exposureTimes: 1,
                businessInfo: {},
              });
            }
          }
          if (item.type === FREE_RIGHT_TYPE.taxi) {
            if (!this.isOpen) {
              UBT.moduleExpose({
                pageId: 'platform_savemoneycard_page',
                categoryId: 'platform',
                moduleId: 'platform_miandan_shun',
                contentId: 'platform_miandan_shun',
                exposureTimes: 1,
                businessInfo: {},
              });
            } else {
              UBT.moduleExpose({
                pageId: 'platform_savemoneycard_page',
                categoryId: 'platform',
                moduleId: 'platform_maindan_vip_shun',
                contentId: 'platform_maindan_vip_shun',
                exposureTimes: 1,
                businessInfo: {},
              });
            }
          }

          if (item.type === FREE_RIGHT_TYPE.hitch) {
            if (!this.isOpen) {
              UBT.moduleExpose({
                pageId: 'platform_savemoneycard_page',
                categoryId: 'platform',
                moduleId: 'platform_miandan_zu',
                contentId: 'platform_miandan_zu',
                exposureTimes: 1,
                businessInfo: {},
              });
            } else {
              UBT.moduleExpose({
                pageId: 'platform_savemoneycard_page',
                categoryId: 'platform',
                moduleId: 'platform_maindan_vip_zu',
                contentId: 'platform_maindan_vip_zu',
                exposureTimes: 1,
                businessInfo: {},
              });
            }
          }


          if (item.type === FREE_RIGHT_TYPE.lottery) {
            if (!this.isOpen) {
              UBT.moduleExpose({
                pageId: 'platform_savemoneycard_page',
                categoryId: 'platform',
                moduleId: 'platform_miandan_shenghuo',
                contentId: 'platform_miandan_shenghuo',
                exposureTimes: 1,
                businessInfo: {},
              });
            } else {
              UBT.moduleExpose({
                pageId: 'platform_savemoneycard_page',
                categoryId: 'platform',
                moduleId: 'platform_maindan_vip_shenghuo',
                contentId: 'platform_maindan_vip_shenghuo',
                exposureTimes: 1,
                businessInfo: {},
              });
            }
          }
        });
      }
    },
    showItem(item) {
      const { type } = item;
      if (type && type !== FREE_RIGHT_TYPE.lottery) {
        return true;
      }
      return item.type === FREE_RIGHT_TYPE.lottery && item.lotteryList && item.lotteryList.length;
    },
    handleCardClick: debounce(function cardClick(item, $event) {
      this.handleCardClickUBT(item);
      if (!this.isOpen) {
        this.$emit('clickFreeRight');
        return;
      }
      if (this.isOpen) {
        const { type, status } = item;
        if (type === FREE_RIGHT_TYPE.bike && status && status !== FREE_RIGHT_STATUS.canReceive) {
          this.redirectToBus(item);
          return;
        }
        if (type === FREE_RIGHT_TYPE.lottery) {
          this.handleLotterySwiperClick(item, $event);
        }
      }
    }, 300, { leading: true, trailing: false }),
    handleCardClickUBT(item) {
      const { type } = item;
      if (type === FREE_RIGHT_TYPE.bike) {
        if (!this.isOpen) {
          UBT.clickButton({
            pageId: 'platform_savemoneycard_page',
            buttonName: 'platform_miandan_bike',
            categoryId: 'platform',
            businessInfo: {},
          });
        } else {
          UBT.clickButton({
            pageId: 'platform_savemoneycard_page',
            buttonName: 'platform_maindan_vip',
            categoryId: 'platform',
            businessInfo: {},
          });
        }
      }
      if (type === FREE_RIGHT_TYPE.taxi) {
        if (!this.isOpen) {
          UBT.clickButton({
            pageId: 'platform_savemoneycard_page',
            buttonName: 'platform_miandan_shun',
            categoryId: 'platform',
            businessInfo: {},
          });
        } else {
          UBT.clickButton({
            pageId: 'platform_savemoneycard_page',
            buttonName: 'platform_maindan_vip_shun',
            categoryId: 'platform',
            businessInfo: {},
          });
        }
      }
      if (type === FREE_RIGHT_TYPE.hitch) {
        if (!this.isOpen) {
          UBT.clickButton({
            pageId: 'platform_savemoneycard_page',
            buttonName: 'platform_miandan_zu',
            categoryId: 'platform',
            businessInfo: {},
          });
        } else {
          UBT.clickButton({
            pageId: 'platform_savemoneycard_page',
            buttonName: 'platform_maindan_vip_zu',
            categoryId: 'platform',
            businessInfo: {},
          });
        }
      }
      if (type === FREE_RIGHT_TYPE.lottery) {
        if (!this.isOpen) {
          UBT.clickButton({
            pageId: 'platform_savemoneycard_page',
            buttonName: 'platform_miandan_shenghuo',
            categoryId: 'platform',
            businessInfo: {},
          });
        } else {
          UBT.clickButton({
            pageId: 'platform_savemoneycard_page',
            buttonName: 'platform_maindan_vip_shenghuo',
            categoryId: 'platform',
            businessInfo: {},
          });
        }
      }
    },


    getButtonClass(item) {
      const { type, status } = item;
      if (type !== FREE_RIGHT_TYPE.lottery) {
        return {
          used: status === FREE_RIGHT_STATUS.used,
        };
      }
      if (type === FREE_RIGHT_TYPE.lottery) {
        return {
          used: status === LOTTERY_PRIZE_STATUS.drawing || status === LOTTERY_PRIZE_STATUS.signed,
        };
      }
      return {};
    },
    handleLotterySwiperClick(item, event) {
      try {
        const button = event && event.target.closest('.button');

        if (button) {
          // 点击了按钮
          // 查找最近的lottery-good元素来获取数据属性
          const lotteryGood = button.closest('.lottery-good');
          if (!lotteryGood) return;
          const { itemIndex } = lotteryGood.dataset || {};

          // 获取对应点击数据
          const lotteryItem = item.lotteryList[itemIndex];
          if (!lotteryItem) return;

          const { status } = lotteryItem;

          switch (status) {
            case LOTTERY_PRIZE_STATUS.draw_limited:
              eventBus.$emit('clickLockLottery');
              break;
            case LOTTERY_PRIZE_STATUS.draw_access:
              this.joinLotteryDraw(lotteryItem);
              break;
            case LOTTERY_PRIZE_STATUS.signed:
              Toast.show('活动已参与，今日20点开奖');
              break;
            case LOTTERY_PRIZE_STATUS.drawing:
              Toast.show('活动正在开奖中');
              break;
            default:
              break;
          }
        } else {
          this.redirectToLotteryPage();
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('handleLotterySwiperClick error:', error);
      }
    },
    async joinLotteryDraw(item = {}) {
      LotteryUtils.joinLotteryDraw(
        item,
        (data) => {
          // 成功回调
          this.involvedData = data;
          this.showInvolvedDialog = true;
          // 设置日历提醒
          LotteryUtils.setRemind(
            item,
            true,
            this.haveSubscribed,
            () => {
              this.haveSubscribed = true;
              Toast.show('添加日历提醒成功，将在开抢前10分钟提醒您');
            },
            (e) => {
              Toast.show('添加日历提醒失败');
              // eslint-disable-next-line no-console
              console.log('添加日历失败的原因', e);
            },
          );
          this.$emit('refreshData');
        },
        () => {
          // 失败回调
          Toast.show('参与失败');
        },
      );
    },
    clickButton(item) {
      const { type, status } = item;
      // 其他类型免单 单顺租
      if (type && type !== FREE_RIGHT_TYPE.lottery) {
        switch (status) {
          case FREE_RIGHT_STATUS.canReceive:
            this.receiveCoupon(item);
            break;
          case FREE_RIGHT_STATUS.book_car:
          case FREE_RIGHT_STATUS.rent_car:
            this.redirectToBus(item);
            break;
          default:
        }
      }
      // 由于swiper点击不到虚拟节点，所以抽奖类型不在此处处理，在外层卡片处理
    },
    async receiveCoupon(item) {
      const { userVipPropGuid, propCode, propName } = item;
      const { token } = await getTokenAndKey();
      const params = {
        token, userVipPropGuid, propCode, propName,
      };
      receiveVipCoupon(params)
        .then(() => {
          Toast.show('领取成功');
          this.$emit('refreshData');
        })
        .catch(() => {
          Toast.show('领取失败');
        });
    },
    redirectToBus(item) {
      const { redirectUrl = '' } = item;
      Navigator.go(redirectUrl);
    },
    redirectToLotteryPage() {
      const recordUrl = `https://m.hellobike.com/AppPlatformH5/${config.env === 'pro' ? '' : `${config.env === 'dev' ? 'fat' : config.env}/`}latest/index.html#/vip/v3/lotteryRecord`;
      // const lotteryPagePath = `http://172.20.30.163:1024//#/vip/v3/lotteryRecord?campaignCode=${this.campaignCode}&batchNo=${this.batchNo}`;
      const pagePath = ParamsUtil.addParams(recordUrl, {
        currentOrderOptType: this.currentOrderOptType !== undefined ? this.currentOrderOptType : null,
        campaignCode: this.campaignCode || '',
        batchNo: this.batchNo || '',
      });
      Navigator.go(pagePath);
      this.isJumpRecordPage = true;
    },
    initSwiper() {
      // 若无抽奖类型 或 没有抽奖数据，则不初始化swiper
      const lotteryTypeRight = this.moduleData && this.moduleData.cardPropInfoDTOList && this.moduleData.cardPropInfoDTOList.find((item) => item.type === FREE_RIGHT_TYPE.lottery);
      const lotteryListLength = lotteryTypeRight && lotteryTypeRight.lotteryList && lotteryTypeRight.lotteryList.length;
      if (!lotteryListLength) return;
      this.campaignCode = lotteryTypeRight.lotteryList[0].campaignCode;
      this.batchNo = lotteryTypeRight.lotteryList[0].batchNo;
      if (this.lotterySwiper && this.lotterySwiper.destroy) {
        this.lotterySwiper.destroy(true, true);
      }
      this.$nextTick(() => {
        this.lotterySwiper = new Swiper('.swiper-container', {
          direction: 'vertical',
          autoplay: lotteryListLength > 1 ? {
            delay: 5000,
            disableOnInteraction: false, // 如果设置为false，用户操作swiper之后自动切换不会停止，每次都会重新启动autoplay。
          } : false,
          loop: true,
          allowTouchMove: false, // 禁止触摸滑动
          simulateTouch: false, // 禁止模拟触摸（适用于PC端鼠标拖动）
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import '../../../../../styles/mixin.less';

.free-rights-container {
  margin-bottom: 0.08rem;
  width: 100%;
  position: relative;
  padding-top: 0.1rem;

  .free-rights-title {
    width: 2.66rem;
    height: 0.35rem;
    display: block; // 添加这行，使img变为块级元素
    // object-fit: contain;
    margin: 0 auto 0.1rem;
  }

  .free-rights-list {
    display: flex;
    flex-wrap: wrap;
    font-family: "PingFang SC", sans-serif;
    margin: 0 0.08rem;
    justify-content: space-between;

    .free-right-item {
      // 两个元素之间间距为0.05rem，以下是一半
      width: calc(50% - 0.025rem);
      height: 0.96rem;
      background-size: 100% 100%;
      padding-left: 0.12rem;
      position: relative;

      // 不是前两个的元素添加上边距
      &:nth-child(n+3) {
        margin-top: 0.05rem;
      }

      .corner-tip {
        position: absolute;
        top: 0;
        right: 0;
        color: #fff;
        font-size: 0.12rem;
        font-weight: 400;
        display: flex;
        align-items: center;
        height: 0.18rem;
        border-radius: 0 0.12rem 0 0.1rem;
        background: rgba(0, 0, 0, 0.6);
        padding: 0 0.12rem;
        line-height: 0.18rem;
        z-index: 2;

        &::after {
          content: '';
          margin-left: 0.025rem;
          width: 0.04rem;
          height: 0.06rem;
          background-image: url('https://m.hellobike.com/resource/gallery/43/gRuLB2l4_89198293.png');
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }
      }

      .card-info {
        margin-top: 0.01rem;
        height: 0.17rem;
        line-height: 0.17rem;
        color: #fff;
        font-family: "PingFang SC", sans-serif;
        font-size: 0.12rem;
        font-weight: 400;
        max-width: 0.94rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .item-content {
        position: relative;
        height: 100%;
        width: 100%;
        overflow: hidden;

        .swiper-wrapper {
          height: 100%;
          width: 100%;
        }

        .swiper-slide {
          height: 100%;
          width: 100%;
          overflow: hidden;
        }
      }

      .bus-icon {
        margin-top: 0.13rem;
        width: 0.22rem;
        height: 0.22rem;
      }

      .main-title {
        height: 0.22rem;
        line-height: 0.22rem;
        color: #fff;
        font-family: "PingFang SC", sans-serif;
        font-size: 0.16rem;
        font-weight: 600;
      }

      .num-and-desc {
        display: flex;
        color: #fff;
        align-items: flex-end;
        margin-top: 0.02rem;

        .card-number {
          height: 0.27rem;
          line-height: 0.27rem;
          font-family: DINAlternate, sans-serif;
          font-size: 0.22rem;
          font-weight: 700;
        }

        .card-number-description {
          font-size: 0.12rem;
          font-weight: 400;
          height: 0.27rem;
          line-height: 0.27rem;
        }
      }

      .lottery-icon {
        position: absolute;
        right: 0.06rem;
        bottom: 0.04rem;
        width: 0.6rem;
        height: 0.6rem;
        object-fit: contain;
      }

      // 已开卡状态
      &.opened {
        .main-title {
          margin-top: 0.12rem;
        }

        .card-info {
          margin-top: 0;
        }

        .num-and-desc {
          margin-top: 0.09rem;
        }

        .button {
          margin-top: 0.08rem;
          width: 0.6rem;
          height: 0.24rem;
          line-height: 0.24rem;
          border-radius: 0.24rem;
          background: linear-gradient(90deg, #fff7eb 2.77%, #fde1c5 99.97%);
          text-align: center;
          color: #371300;
          font-size: 0.12rem;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;


          // status为2时显示锁图标
          &.locked::before {
            margin-right: 0.005rem;
            padding-bottom: 0.02rem;
            content: '';
            // position: absolute;
            // left: 0.05rem;
            // top: 50%;
            // transform: translateY(-50%);
            width: 0.12rem;
            height: 0.12rem;
            background-image: url('https://m.hellobike.com/resource/gallery/43/J2LFmUi-_18291293.png');
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
          }

          &.used {
            width: 0.6rem;
            height: 0.24rem;
            line-height: 0.24rem;
            border-radius: 0.24rem;
            background: transparent;
            color: rgba(255, 255, 255, 0.4);
            text-align: center;
            font-size: 0.12rem;
            font-weight: 500;
            .thin-border(rgba(255, 255, 255, 0.4), 0.01rem, 0.4rem);
          }
        }

        .remain-days {
          margin-top: 0.075rem;
          position: relative;

          &::after {
            margin-bottom: 0.01rem;
            margin-left: 0.02rem;
            display: inline-block;
            content: '';
            width: 0.04rem;
            height: 0.06rem;
            background-image: url('https://assets.51downapp.cn/file-1755005000842-544663195.png');
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }
    }
  }
}
</style>
